//
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';

const fragments = {
  PRODUCT_SLIDER: '[data-fragment="EshopFulltextAutocomplete.productSlider"]',
};

// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';

class EshopFulltextAutocomplete extends WebComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleMouseover = this.handleMouseover.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClearInput = this.handleClearInput.bind(this);
    this.state = {
      submitButtonDisabled: true,
    }
  }

  didMount() {
    const {
      querySelector,
      categorySelector,
      submitButtonSelector,
      focusOnAppear,
    } = this.props;

    this.html = document.documentElement;
    this.categoryInputElement = this.element.querySelector(categorySelector);
    this.queryInputElement = this.element.querySelector(querySelector);
    this.submitButtonElement = this.element.querySelector(submitButtonSelector);
    this.keyUpTimer = null;
    this.autocompleteOpened = false;

    this.renderedResultElement = null;
    this.valBeforeKeyPress = '';
    this.selectedItem = -1;

    if (this.queryInputElement) {
      this.queryInputElement.setAttribute('autocomplete', 'off');
      this.hasCategorySelect = !!this.categoryInputElement;

      this.queryInputElementIsVisibleOnInit = !(this.queryInputElement.offsetParent === null);

      this.clearButton = this.renderClearButton();

      this.queryInputElement.addEventListener('keyup', this.handleKeyup);
      this.queryInputElement.addEventListener('input', this.handleKeyup);
      this.on('submit', this.handleSubmit);
      window.addEventListener('click', this.handleClickOutside);

      if (this.clearButton) {
        this.updateClearButtonVisibility();
        this.clearButton.addEventListener('click', this.handleClearInput);
      }

      if (focusOnAppear && !this.queryInputElementIsVisibleOnInit) {
        this.handleFocusOnAppear();
      }

      this.setState({
        submitButtonDisabled: this.queryInputElement.value == ''
      });
    }
  }

  willUnMount() {
    window.removeEventListener('click', this.handleClickOutside);
    this.queryInputElement.removeEventListener('keyup', this.handleKeyup);
    this.queryInputElement.removeEventListener('input', this.handleKeyup);
    if (this.clearButton) {
      this.clearButton.removeEventListener('click', this.handleClearInput);
    }
  }

  renderClearButton() {
    const {
      showClearButton,
    } = this.props;

    let result = null;

    if (showClearButton) {
      result = document.createElement('span');
      result.classList.add('form-fulltext__clear-button');

      // create svg icon
      const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgIcon.classList.add('svg-icon');

      const svgLink = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      svgLink.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/build/img/svg/svg-sprite.svg#close-thin');
      svgIcon.appendChild(svgLink);

      result.appendChild(svgIcon);

      this.queryInputElement.parentNode.insertBefore(result, this.queryInputElement.nextSibling);
    }

    return result;
  }

  updateClearButtonVisibility() {
    if (this.clearButton) {
      this.clearButton.style.display = this.queryInputElement.value == '' ? 'none' : 'block';
    }
  }

  handleClearInput() {
    this.queryInputElement.value = '';
    this.updateClearButtonVisibility();
    this.removeAutocompleteResult();
  }

  handleFocusOnAppear() {
    const observer = new IntersectionObserver((entries) => {
        if(entries[0].isIntersecting === true)
          this.queryInputElement.focus();
      }, { threshold: [0] });

    observer.observe(this.queryInputElement);
  }

  handleClickOutside(event) {
    if (this.element && this.autocompleteOpened && event.target != this.element && !(event.target.closest(`#${this.element.id}`))) {
      this.removeAutocompleteResult();
    }
  }

  handleSubmit(event) {
    if (typeof (Turbolinks) != 'undefined') {
      const postUrl = this.element.getAttribute('action');
      const requestMethod = this.element.getAttribute('method');
      const data = new FormData(event.target);
      const xhr = new XMLHttpRequest();

      event.preventDefault();
      CursorSpinner.pushToQueue('fulltextAutocomplete');

      xhr.open(requestMethod, postUrl);
      xhr.onreadystatechange = () => {
        if (xhr.readyState == XMLHttpRequest.DONE) {
          CursorSpinner.removeFromQueue('fulltextAutocomplete');

          if (xhr.status == 200) {
            Turbolinks.visit(xhr.responseURL);
          }
        }
      };
      xhr.send(data);
    }
  }

  /**
   * bind keyup akce - psaní textu do query inputu
   */
  handleKeyup(event) {
    const {
      minimalLength,
      timerMilliseconds,
    } = this.props;

    this.updateClearButtonVisibility();

    this.setState({
      submitButtonDisabled: this.queryInputElement.value == ''
    });

    clearTimeout(this.keyUpTimer);
    const val = event.currentTarget.value;

    if (val.length < minimalLength) {
      this.removeAutocompleteResult();
      return false;
    }

    if (this.valBeforeKeyPress == val) return false;

    this.keyUpTimer = setTimeout(() => {
      this.performSearch(val);
    }, timerMilliseconds);
  }

  /**
   * samotné vyhledání dotazu - AJAX
   * @param query
   */
  performSearch(query) {
    const {
      url,
    } = this.props;

    this.element.classList.add('fa-loading');
    let data = new URLSearchParams();
    data.set('query', query);
    if (this.hasCategorySelect) {
      const categoryValue = this.categoryInputElement.value;
      if (categoryValue && categoryValue != '') {
        data.set('category', categoryValue);
      }
    }

    data.set('_', new Date().getTime());

    const xhr = new XMLHttpRequest();
    CursorSpinner.pushToQueue('fulltextAutocomplete');

    xhr.open('GET', url + '?' + data.toString());
    xhr.send();

    xhr.onreadystatechange = () => {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        CursorSpinner.removeFromQueue('fulltextAutocomplete');

        if (xhr.status == 200) {
          this.renderResults(xhr.responseText, query);
        }
      }
    };
  }

  renderResults(data, query) {
    const {
      showNoResultsMessage,
      resultSelector,
      renderAfterElement,
    } = this.props;

    setTimeout(() => {
      const frLink = document.querySelectorAll('.fr-list__more-btn');

      frLink.forEach((link)=>{
        const target = link.dataset.tabTarget;
        link.setAttribute('href', '/hledej/'+query+'?section='+target);
      })
    }, 200);

    this.selectedItem = -1;
    this.removeAutocompleteResult();

    this.element.classList.remove('fa-loading');

    if (renderAfterElement) {
      document.querySelector(renderAfterElement).insertAdjacentHTML('afterend',data);
    }
    else {
      this.queryInputElement.parentNode.insertAdjacentHTML('beforeend', data);
    }

    this.renderedResult = document.querySelector(resultSelector);

    const results = this.renderedResult.querySelectorAll('li').length + this.renderedResult.querySelectorAll('.fr-list__item').length;

    if (results == 0) {
      this.renderedResult.classList.add('fulltext-autocomplete--no-result');
      if (showNoResultsMessage) {
        this.renderedResult.classList.remove('hidden');
        this.autocompleteOpened = true;

        this.noResultMessage = document.createElement('span');
        this.noResultMessage.classList.add('fulltext-autocomplete__no-result');
        this.noResultMessage.innerHTML = this.i18n('noResults');
        this.renderedResult.querySelector('.fulltext-autocomplete__content').appendChild(this.noResultMessage);
      }
      else {
        this.renderedResult.classList.add('hidden');
        this.autocompleteOpened = false;
      }
    } else {
      this.renderedResult.classList.remove('fulltext-autocomplete--no-result');
      this.renderedResult.classList.remove('hidden');
      this.autocompleteOpened = true;
    }

    this.renderMoreLink();
    this.bindAutocompleteResultEvents();
  }

  renderMoreLink() {
    const {
      moreResultsLimit,
    } = this.props;
    const products = this.renderedResult.querySelectorAll('.fulltext-autocomplete-product-list li').length;
    const categories = this.renderedResult.querySelectorAll('.fulltext-autocomplete-category-list li').length;
    const html = `<ul class="fulltext-autocomplete__list fulltext-autocomplete__list--more fulltext-autocomplete-list fulltext-autocomplete-more"><li class="fulltext-autocomplete__item"><a href="#" class="fulltext-autocomplete__link">${this.i18n('moreResults')}</a></li></ul>`;

    if ((products > moreResultsLimit) || (categories > moreResultsLimit)) {
      this.renderedResult.insertAdjacentHTML('beforeend', html);
    }
  }


  /**
   * removes rendered resuts, if any
   */
  removeAutocompleteResult() {
    if (this.renderedResult && this.renderedResult.parentNode) {
      this.renderedResult.parentNode.removeChild(this.renderedResult);
      this.autocompleteOpened = false;
      this.html.classList.remove('fulltext--on');
    }
    this.selectedItem = -1;
  }

  handleKeydown(event) {
    this.valBeforeKeyPress = this.queryInputElement.value;

    if (this.renderedResult) {
      const result = this.renderedResult.querySelectorAll('li').length;

      // down
      if (event.keyCode == 40) {
        event.preventDefault();
        if (this.selectedItem < result - 1) {
          this.selectedItem++;
        }
      }

      // up
      if (event.keyCode == 38) {
        event.preventDefault();
        if (this.selectedItem > 0) {
          this.selectedItem--;
        }
      }

      //enter
      if (event.keyCode == 13) {

        if (this.selectedItem > -1 && this.selectedItem < result) {
          event.preventDefault();
          this.renderedResult.querySelectorAll('li')[this.selectedItem].querySelector('a:first-child').click();
        } else {
          this.removeAutocompleteResult();
        }
      }

      //escape
      if (event.keyCode == 27) {
        event.preventDefault();
        this.queryInputElement.value = '';
        this.removeAutocompleteResult();
      }

      this.removeActiveClassFromItems();

      if (this.selectedItem > -1) {
        this.renderedResult.querySelectorAll('li')[this.selectedItem].classList.add('active');
      }
    }
  }

  removeActiveClassFromItems() {
    const items = this.renderedResult.querySelectorAll('li');
    items.forEach((item, index) => {
      item.classList.remove('active');
      item.setAttribute('data-index', index);
    });
  }

  handleMouseover(event) {
    this.removeActiveClassFromItems();
    event.currentTarget.classList.add('active');
    this.selectedItem = event.currentTarget.getAttribute('data-index');
  }

  handleClick(event) {
    const element = event.currentTarget;

    if (element.getAttribute('href') && element.getAttribute('href') == '#') {
      event.preventDefault();
      this.element.submit();
    }
  }

  bindAutocompleteResultEvents() {
    this.queryInputElement.removeEventListener('keydown', this.handleKeydown);
    this.queryInputElement.addEventListener('keydown', this.handleKeydown);
    const items = this.renderedResult.querySelectorAll('li');
    items.forEach((item) => {
      item.removeEventListener('mouseover', this.handleMouseover);
      item.addEventListener('mouseover', this.handleMouseover);
      item.querySelector('a:first-child').removeEventListener('click', this.handleClick);
      item.querySelector('a:first-child').addEventListener('click', this.handleClick);
    });

    this.html.classList.add('fulltext--on');

    // calculating heights to set when autocomplete opens
    const faMargin = 40;
    this.fulltextAutocomplete = document.querySelector('.fulltext-autocomplete__content');
    const faDimensions = this.fulltextAutocomplete.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    this.fulltextAutocomplete.style.maxHeight = `${Math.ceil(viewportHeight - faDimensions.top - faMargin) }px`;

    this.swiperElement = this.element.querySelector(fragments.PRODUCT_SLIDER);

    this.swipers = new Swiper(this.swiperElement, {
      modules: [Navigation, Pagination],
      loop: false,
      slidesPerGroup: 2,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 4,
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 2,
      breakpoints: {
        480: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
      },
    });
  }

  update = (e) => {
    const {
      submitButtonDisabled,
    } = this.state;

    this.submitButtonElement.disabled = submitButtonDisabled;
  }

}

EshopFulltextAutocomplete.defaultProps = {
  querySelector: '#query',
  categorySelector: '#category',
  submitButtonSelector: '#send',
  resultSelector: '.fulltext-autocomplete',
  url: null,
  timerMilliseconds: 400,
  minimalLength: 2,
  moreResultsLimit: 1,
  showNoResultsMessage: true,
  focusOnAppear: true,
  showClearButton: true,
};

export default EshopFulltextAutocomplete;



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/EshopFulltextAutocomplete.js